import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=6d4714f6"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=6d4714f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@neverendingsupport+vue2@2.7.22-template-compiler_css-loader@6.8.1_w_ac75f654c89b93f746c150b40366f7f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports